import { Box } from '@byecode/ui'
import type { TypeInstanceMap, VariableADTvalue } from '@lighthouse/core'
import React from 'react'

import type { VariableTree2 } from '../../Variable'
import { VariableSelect } from '../../Variable/VariableSelect'
import type { EditBackgroundProtocol } from '../type'

export interface VariableContainerProps {
    value: EditBackgroundProtocol
    onChange: (value: EditBackgroundProtocol) => void
    innerTypes?: TypeInstanceMap[]
    pageOptions?: VariableTree2[]
    viewOptions?: VariableTree2[]
    userOption?: VariableTree2
    inputOption?: VariableTree2
}

export const VariableContainer: React.FC<VariableContainerProps> = ({
    value,
    onChange,
    innerTypes,
    inputOption,
    pageOptions,
    viewOptions,
    userOption
}) => {
    const handleVariableChange = (variable: VariableADTvalue) => {
        onChange({
            ...value,
            variable
        })
    }

    return (
        <Box py={4}>
            <VariableSelect
                style={{ width: '100%' }}
                width="100%"
                value={value.variable}
                onChange={handleVariableChange}
                placeholder="请选择变量"
                innerTypes={innerTypes}
                inputOption={inputOption}
                pageOptions={pageOptions}
                viewOptions={viewOptions}
                userOption={userOption}
            />
        </Box>
    )
}
